import styled from 'styled-components'
import { Dropdown } from 'react-bootstrap'
import { breakpoints, colors } from 'style'

export const StyledDropdownContainer = styled(Dropdown)`
  display: flex;
  &.show {
    .dropdown-toggle {
      background-color: transparent !important;
      border-color: #fff !important;
      color: ${colors.grayLight};
    }
  }
  .dropdown-toggle {
    color: ${colors.grayLight};
    border-radius: 7px;
    border: solid 1px white;
    background-color: transparent;
    font-size: 14px;
    font-weight: normal;
    padding: 0 16px;
    &:hover,
    &:focus,
    &:active,
    &:focus {
      background-color: transparent !important;
      border-color: #fff !important;
      box-shadow: unset !important;
    }
    &.disabled:hover {
      transform: unset;
    }
  }
  .dropdown-menu {
    padding: 0;
    &.show {
      border-radius: 7px;
      border: solid 1px #000;
      background-color: white;
      min-width: 75px;
      width: 100%;
      a:first-of-type {
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
      }
      a:last-child {
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
      }
      a {
        p {
          margin-bottom: 0;
        }
      }
      a:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
  @media (max-width: ${breakpoints.xs}px) {
    .dropdown-toggle {
      padding: 0;
    }
    .dropdown-menu {
      position: absolute;
    }
  }
`
